module.exports = __webpack_public_path__ + "img/thumb-globalx.f2b9cb45.png";